module.exports = "/assets/data/2dc0642ace7b38b788a4b8803c1f6cd3-CV1.data.json";